import { useLang } from "../../context/LanguageContext";
import { useContent } from "../../context/ContentContext";
import { AMENITIES } from "../../data/content";
import { Reveal, SectionHeading } from "../Reveal";
import { Icon } from "../Icon";

export const Amenities = () => {
  const { t } = useLang();
  const { content } = useContent();
  const disabledKeys = new Set(
    (content.amenities || []).filter((a) => a.enabled === false).map((a) => a.key)
  );
  const list = AMENITIES.filter((a) => !disabledKeys.has(a.key));
  return (
    <section id="amenities" className="scroll-mt-20 bg-[#F3EFEA] px-4 sm:px-8 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <SectionHeading eyebrow={t("amenities.eyebrow")} title={t("amenities.title")} subtitle={t("amenities.subtitle")} />
        </Reveal>
        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {list.map((a, i) => (
            <Reveal key={a.key} delay={Math.min(i * 0.04, 0.3)}>
              <div
                data-testid={`amenity-${a.key}`}
                className="group flex h-full flex-col items-start gap-3 rounded-2xl border border-stone-200/80 bg-white p-5 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-[#C85A32]/40 hover:shadow-lg hover:shadow-stone-200/60"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#C85A32]/10 text-[#C85A32] transition-colors group-hover:bg-[#C85A32] group-hover:text-white">
                  <Icon name={a.icon} className="h-5 w-5" />
                </span>
                <span className="text-sm font-semibold text-stone-800">{t(`amenities.items.${a.key}`)}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
